import { render, staticRenderFns } from "./ProductTaxes.vue?vue&type=template&id=1a1a184c&scoped=true"
import script from "./ProductTaxes.vue?vue&type=script&lang=ts"
export * from "./ProductTaxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a184c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1a184c')) {
      api.createRecord('1a1a184c', component.options)
    } else {
      api.reload('1a1a184c', component.options)
    }
    module.hot.accept("./ProductTaxes.vue?vue&type=template&id=1a1a184c&scoped=true", function () {
      api.rerender('1a1a184c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ProductTaxes.vue"
export default component.exports